import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Settings } from '../../developer-settings.setup';
import { SettingsWebhooksManagementWebhooksTab } from './tabs';

const parent = Settings.pages.webhooksManagement;
const title = 'PAGE.DEVELOPER_SETTINGS.WEBHOOKS_MANAGEMENT.TITLE';
const tabs: TabPermission[] = [SettingsWebhooksManagementWebhooksTab];

export const SettingsWebhooksManagementPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
